// extracted by mini-css-extract-plugin
export default {"logoImg":"Logo_logoImg__TKsp9"};